module.exports = __webpack_public_path__ + "assets/coordinate.28405db5.svg";